<template>
  <div v-if='tokenUser["admin"]' class='is-flex' :class='isMovil ? "is-justify-center" : "" '>
    <button
        class="button is-dark"
        v-tooltip='"Crear nuevo proceso"'
        v-on:click='openModalCreatedProcess()'
    >
          Crear proceso
          <span class="icon" style='margin-left: 5px'>
            <i class="material-icons">add_circle</i>
          </span>
    </button>
    <button
        class="button is-dark"
        v-tooltip='"Crear consolidado"'
        v-on:click='opendModalConsolidated()'
        style='margin-left: 5px'
    >
      <span class="icon">
        <i class="material-icons">library_add</i>
      </span>
    </button>
  </div>
</template>
<script>
import {mapState} from 'vuex'

export default {
  data(){
    return {

    }
  },
  computed:{
    ...mapState(['isMovil','tokenUser']),
  },
  methods:{
    openModalCreatedProcess(){
      this.$emit('closeMenuCreate')
    },
    opendModalConsolidated(){
      this.$emit('closeModalCon')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/lideres/components/menuTableProcess.vue